import { useEffect, useState } from "react";
import CustomLoader from "../../../components/common/CustomLoader";
import { BasePageContainer } from "../../../components/common";
import { Button, ButtonGroup } from "react-bootstrap";
import { getPricePredictionDashboard } from "../../../service/ai-model.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faTableCells } from "@fortawesome/free-solid-svg-icons";
import { DashboardViewType } from "../../../helper/constant";

const ViewType = {
    TILE: 'tile',
    LIST: 'list'
}

const PreditionDashboard = () => {
    const [loading, setLoading] = useState(false);
    const [selectedFilters, setSelectedFilters] = useState({});
    const [filteredCars, setFilteredCars] = useState([]);
    const [viewType, setViewType] = useState(ViewType.LIST); // 'tile' or 'list'

    useEffect(() => {
        setLoading(true);
        const params = new URLSearchParams(window.location.search)
        const org = params.get('org');
        getPricePredictionDashboard({ org, type: DashboardViewType.PREDICTION })
            .then((res) => setFilteredCars(res.data))
            .finally(() => setLoading(false));
    }, []);

    const onFilterSelect = (filter, name) => {
        const filterData = { ...selectedFilters };
        if (filter === 'all') {
            delete filterData[name];
        } else {
            filterData[name] = filter;
        }
        setSelectedFilters(filterData);
        // applyFilters(filterData);
    }

    const applyFilters = (filterData) => {
        let updatedCars = [...filteredCars];
        Object.keys(filterData).forEach((key) => {
            const value = filterData[key];
            updatedCars = updatedCars.filter((car) => {
                const attr = car.attrs.find((a) => a.name.toLowerCase() === key.toLowerCase());
                return attr && attr.value.toLowerCase().includes(value);
            });
        });
        setFilteredCars(updatedCars);
    }

    const renderTileView = (car) => {
        return (
            <div className="col-sm-12 col-md-6 col-xl-4 px-2" key={car.id}>
                <div className="card shadow-sm px-3 border flex-column d-flex mb-3">
                    {/* Car Image */}
                    <img
                        src={car.image}
                        alt={car.title}
                        className="img-fluid rounded px-3 align-self-center mt-3"
                        style={{ width: "180px", minHeight: 150, maxHeight: 150, objectFit: "cover" }}
                    />
                    {/* Car Details */}
                    <div className="flex-grow-1 my-3">
                        <div className="d-flex flex-column align-items-center">
                            <h5 className="card-title">{car.title}</h5>
                            <div className="d-flex flex-wrap text-muted small mt-2 gap-1">
                                {car.attrs.map(((att, attIndex) => <Attribute key={attIndex} {...att} />))}
                            </div>
                        </div>
                        {/*  Contacts */}
                    </div>
                    {/* Pricing */}
                    <div className="text-end flex-grow-2 d-flex flex-row justify-content-between mb-3 border">
                        <h4 className="font-weight-bold text-center flex-grow-1 d-flex align-items-center justify-content-center bg-light border-right py-4">${car.price.toLocaleString()}</h4>
                        <div className="text-center d-flex flex-grow-1 justify-content-center flex-column bg-light border-right">
                            Predicted Sales Price <br />
                            <span className="font-weight-bold">
                                ${car.predictedPrice.toLocaleString()}
                            </span>
                        </div>

                        <div className={`flex-grow-1 d-flex flex-grow-1 justify-content-center flex-column text-center`}
                            style={{ backgroundColor: car.profit >= 2000 ? '#d4edda' : (car.profit >= 1000 && car.profit <= 2000) ? 'rgba(240,226,194,225)' : '#f8d7da' }}>
                            Profit<br /><span className="font-weight-bold">${car.profit.toLocaleString()}</span>
                        </div>
                    </div>
                    <div className="pred-contact-card-tile">Seller : Marc Andrew, +1 548 2365, +1741 852 9632</div>
                </div>
            </div>
        )
    }

    const renderListView = (car) => {
        return (
            <div
                key={car.id}
                className="card mb-4 pred-card shadow-sm d-flex flex-row"
            >
                <div className="d-flex flex-grow-1 align-self-center">
                    {/* Car Image */}
                    <img
                        src={car.image}
                        alt={car.title}
                        className="img-fluid rounded px-3"
                        style={{ width: "180px", minHeight: 120, maxHeight: 150, objectFit: "cover" }}
                    />

                    {/* Car Details */}
                    <div className="flex-grow-1">
                        <div className="d-flex flex-column align-items-center">
                            <h5 className="card-title">{car.title}</h5>
                            <div className="d-flex flex-wrap text-muted small mt-2 gap-1">
                                {car.attrs.map(((att, attIndex) => <Attribute key={attIndex} {...att} />))}
                            </div>
                        </div>
                        {/*  Contacts */}
                        <Contact message={'Seller : Marc Andrew, +1 548 2365, +1741 852 9632'} />
                    </div>
                </div>
                {/* Pricing */}
                <div className="text-end pred-price-box flex-grow-2 d-flex flex-column justify-content-between">
                    <h4 className="font-weight-bold border-bottom text-center flex-grow-1 d-flex align-items-center justify-content-center bg-light">${car.price.toLocaleString()}</h4>
                    <div className="border-bottom text-center d-flex flex-grow-1 justify-content-center flex-column bg-light">
                        Predicted Sales Price <br />
                        <span className="font-weight-bold">
                            ${car.predictedPrice.toLocaleString()}
                        </span>
                    </div>

                    <div className={`flex-grow-1 d-flex flex-grow-1 justify-content-center flex-column text-center`}
                        style={{ backgroundColor: car.profit >= 2000 ? '#d4edda' : (car.profit >= 1000 && car.profit <= 2000) ? 'rgba(240,226,194,225)' : '#f8d7da' }}>
                        Profit<br /><span className="font-weight-bold">${car.profit.toLocaleString()}</span>
                    </div>
                </div>

            </div>
        )
    }

    const renderFilteredCars = () => {
        if (filteredCars.length === 0) {
            return <div className="text-center">No Cars Found</div>;
        }
        if (viewType === ViewType.TILE) {
            return (
                <div className="row">
                    {filteredCars.map((car) => renderTileView(car))}
                </div>
            )

        }
        return filteredCars.map((car) => renderListView(car))
    }


    const renderPredictionDashboard = () => {
        return (
            <div className="row">
                {/* Filters */}
                <aside className="col-lg-2 mb-4">
                    {filters.map((filter, index) => (
                        <div
                            key={index}
                            className="card mb-2 shadow-sm"
                            style={{ cursor: "pointer" }}
                        >
                            <div className="card-body p-3 d-flex gap-2 justify-content-start align-items-center">
                                <label className="form-label m-0" htmlFor={`filter-${index}`} style={{ minWidth: 100 }}>{filter.name}</label>
                                <select className="form-select pred-filter-select" style={{ minWidth: 130 }} id={`filter-${index}`} onChange={(e) => onFilterSelect(e.target.value, filter.name)}>
                                    <option selected>All</option>
                                    {filter.options.map((option, i) => (
                                        <option key={`option-${i}`} value={option.toLowerCase()}>{option}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    ))}
                </aside>

                {/* Listings */}
                <main className="col-lg-10" style={{ maxHeight: '79vh', overflowY: 'auto' }}>
                    {renderFilteredCars()}
                </main>
            </div>
        )
    }

    const renderViewType = () => {
        return (
            <div className="d-flex justify-content-end gap-1">
                <ButtonGroup aria-label="Basic example">
                    <Button onClick={() => setViewType(ViewType.LIST)} variant={viewType === ViewType.LIST ? 'primary' : 'secondary'} ><FontAwesomeIcon icon={faList} /></Button>
                    <Button onClick={() => setViewType(ViewType.TILE)} variant={viewType === ViewType.TILE ? 'primary' : 'secondary'} ><FontAwesomeIcon icon={faTableCells} /></Button>
                </ButtonGroup>
            </div>)
    }

    return (
        <div className="row mx-0 loginwrap">
            <BasePageContainer>
                {loading && <CustomLoader full />}
                <div className="d-flex flex-column gap-2 px-5 pt-3">
                    {renderViewType()}
                    {renderPredictionDashboard()}
                </div>
            </BasePageContainer>
        </div>
    );
};

export default PreditionDashboard;

const Attribute = ({ icon, name, value, key }) => {
    return (
        <div className="d-flex flex-column gap-1 px-2 border-right" key={key}>
            <div className="d-flex justify-content-center align-items-center gap-1">
                <i>{icon}</i>
                <p className="p-0 m-0">{name}</p>
            </div>
            <p className="p-0 m-0 align-self-end">{value}</p>
        </div>
    )
}

const Contact = ({ message }) => {
    return (
        <div className="pred-contact-card">{message}</div>
    )
}

const filters = [
    {
        name: "Location",
        options: ["Bangalore", "Mumbai", "Delhi"],
    },
    {
        name: "Distance",
        options: ["0 – 50 km", "50 – 100 km", "100+ km"],
    },
    {
        name: "Condition",
        options: ["New", "Used"],
    },
    {
        name: "Make",
        options: ["Toyota", "Honda", "Maruti"],
    },
    {
        name: "Model",
        options: ["Model 1", "Model 2"],
    },
    {
        name: "Year",
        options: ["2025", "2024", "2023", "2022"],
    },
    {
        name: "Mileage",
        options: ["0 – 5,000 km", "5,000 – 20,000 km", "20,000+ km"],
    },
    {
        name: "Fuel type",
        options: ["Petrol", "Diesel", "Electric", "Hybrid"],
    },
    {
        name: "Engine",
        options: ["1000cc", "1500cc", "2000cc"],
    },
    {
        name: "Transmission",
        options: ["Manual", "Automatic"],
    },
    {
        name: "Body Type",
        options: ["SUV", "Sedan", "Hatchback"],
    },
];